import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ModalComponent } from '../modal-component/modal-component.component';
import { cn } from '../../../../utils/utils';
import { StepperControlsComponent } from '../stepper-controls/stepper-controls.component';

let nextTitleId = 0;

@Component({
  selector: 'modal-form-container',
  standalone: true,
  imports: [ModalComponent, StepperControlsComponent],
  templateUrl: './modal-form-container.component.html',
  styleUrl: './modal-form-container.component.css',
})
export class ModalFormContainerComponent {
  merge = cn;

  @Input() title: string = '';
  @Input() className: string = '';
  @Input() contentClass!: string;
  @Input({ required: true }) showModal: boolean = false;
  @Output() closeModalEvent = new EventEmitter();
  @Input() showFooter: boolean = false;
  @Input() footerClass: string = ''
  @Output() leftFooterButtonClick = new EventEmitter();
  @Output() rightFooterButtonClick = new EventEmitter();
  @Input() leftFooterButtonDisabled: boolean = false
  @Input() rightFooterButtonDisabled: boolean = false
  @Input() leftFooterButtonLabel: string = 'Previous'
  @Input() rightFooterButtonLabel: string = 'Add'
  @Input() leftFooterButtonClass: string = 'hidden'
  @Input() rightFooterButtonClass: string = ''
  @Input() footerLoading:boolean = false
  /**
   * Close when the dimmed area is clicked. Off by default: these dialogs hold
   * forms, and a stray click should not throw away what was typed. Escape
   * always closes (it emits closeModalEvent, like the close button).
   */
  @Input() closeOnBackdrop: boolean = false
  showComponentFooter:boolean = false

  readonly titleId = `mfc-title-${nextTitleId++}`;

  closeModal() {
    this.closeModalEvent.emit();
  }

  ngOnChanges(){
    this.showComponentFooter = this.showFooter
  }
}
